export enum UserRoles {
  Admin = "Admin",
  Moderator = "Moderator",
  User = "User",
  Partner = "Partner",
}
